import ReactComponent from '../../../assets/icons/border-selected.svg?react';
import type { FC } from 'react';
import { BaseIcon, IconProps } from './BaseIcon';

export const BorderSelectedIcon: FC<IconProps> = (props) => {
    return (
        <BaseIcon {...props}>
            <ReactComponent />
        </BaseIcon>
    );
};
